import React, { useState, useContext, useEffect } from "react";

import styled, { css, ThemeProvider } from "styled-components";

import {
    CSSuikit0,
    CSSuikitH,
    CSSuikitSection,
    UikitSection,
    ContentBlock,
    Button,
    CssPaper,
    CSSuikitInfo,
    CSSuikitElement,
    HH,
    CssInput,
    CssLabel,
    CssPopSection,
    HR
} from './uikit-b2c';
import { InputM } from "./InputM";
import Bg from "../Bg";

// const psThemeAdd = {
//   paddings: 8,
//   fontSize: '14px',
//   fontFamily: ' -apple-system, system-ui, Graphiklcg, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Droid Sans, Helvetica Neue, Arial, sans-serif',
// }

export default function Uikit({
  active,
  theme,
  handleTab = () => {
    void 0;
  },
  items = [],
  appearance = "primary",
  extra,
}) {
  return (
    <ThemeProvider theme={theme}>
      <CSSps00>
        <CSSuikit0>
          <UikitSection label="Inputs">
            <CSSuikitElement>
              <ContentBlock appearance="flatten" indentation="xlg">
                {/* <InputM
                newStyle={false}
                label="Username"
                placeholder="Username"
              >Users</InputM> */}


              <ContentBlock indentation="lg">
                <HH tag='h3'>Small Inputs</HH>
                </ContentBlock>

                <ContentBlock appearance="flatten" indentation="xlg">
                  <InputM
                    value=""
                    size='sm'
                    handle={() => void 0}
                    label="Label"
                    // placeholder="Small input"
                    autofocus={true}
                  />
                </ContentBlock>

                <ContentBlock appearance="flatten" indentation="xlg">
                  <InputM
                    value=""
                    size='sm'
                    handle={() => void 0}
                    label="Label"
                    placeholder="Placeholder"
                  />
                </ContentBlock>

                <HR/>

                <ContentBlock indentation="lg">
                  <HH tag='h3'>Regular Inputs</HH>
                </ContentBlock>

                <ContentBlock appearance="flatten" indentation="xlg">
                  <InputM
                    value=""
                    handle={() => void 0}
                    label="First name"
                    // placeholder="Ivan"
                    autofocus={false}
                  />
                </ContentBlock>

                <ContentBlock appearance="flatten" indentation="xlg">
                  <InputM
                    value=""
                    handle={() => void 0}
                    label="Last name"
                    size='sm'
                    // placeholder="Ivanov"
                  />
                </ContentBlock>
                <ContentBlock appearance="flatten" indentation="xlg">
                  <InputM
                    value=""
                    handle={() => void 0}
                    label="Input with placeholder"
                    placeholder="Placeholder"
                  />
                </ContentBlock>
                <ContentBlock appearance="flatten" indentation="xlg">
                  <InputM
                    monospace
                    value="**** **** **** 1231"
                    handle={() => void 0}
                    label="Monospace for digits"
                    placeholder=""
                  />
                </ContentBlock>


                <HR/>

                <ContentBlock indentation="lg">
                  <HH tag='h3'>Validation</HH>
                </ContentBlock>

                <ContentBlock appearance="flatten" indentation="xlg">
                  <InputM
                    monospace={true}
                    value="08/11"
                    handle={() => void 0}
                    label="Card expiry"
                    // placeholder="Ivan"
                    autofocus={false}
                  />
                </ContentBlock>



              </ContentBlock>
              <CSSuikitInfo>
                <p>
                  {`<InputM
                  value='Value'
                  handle={()=>void(0)}
                  label="Fisrst name"
                  autofocus={true}
                  placeholder="Ivan"
                />`}
                </p>
              </CSSuikitInfo>
            </CSSuikitElement>
          </UikitSection>

          <UikitSection label="Buttons">
            <CSSuikitElement>
              <ContentBlock>
                <Button
                  appearance="primary"
                  //
                >
                  Default
                </Button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Button appearance="primary" size="lg">
                  Lg
                </Button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Button appearance="primary" size="sm">
                  Sm
                </Button>
              </ContentBlock>
              <CSSuikitInfo>
                <p>
                  appearance="primary"
                  <br />
                  size="md"
                  <br />
                  size="lg"
                  <br />
                  size="sm"
                  <br />
                </p>
              </CSSuikitInfo>
            </CSSuikitElement>

            <CSSuikitElement>
              <ContentBlock>
                <Button appearance="secondary">Default</Button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Button appearance="secondary" size="lg">
                  Lg
                </Button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Button appearance="secondary" size="sm">
                  Sm
                </Button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Button appearance="secondary" size="xs">
                  Xs
                </Button>
              </ContentBlock>
              <CSSuikitInfo>
                <p>
                  appearance="secondary"
                  <br />
                  size="md"
                  <br />
                  size="lg"
                  <br />
                  size="sm"
                  <br />
                </p>
              </CSSuikitInfo>
            </CSSuikitElement>

            <CSSuikitElement>
              <ContentBlock>
                <Button appearance="ghost">Default</Button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Button appearance="ghost" size="lg">
                  Lg
                </Button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Button appearance="ghost" size="sm">
                  Sm
                </Button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Button appearance="ghost" size="xs">
                  Xs
                </Button>
              </ContentBlock>
              <CSSuikitInfo>
                <p>
                  appearance="ghost"
                  <br />
                  size="md"
                  <br />
                  size="lg"
                  <br />
                  size="sm"
                  <br />
                </p>
              </CSSuikitInfo>
            </CSSuikitElement>

            <CSSuikitElement>
              <ContentBlock>
                <Button appearance="flatten">Default</Button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Button appearance="flatten" size="lg">
                  Lg
                </Button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Button appearance="flatten" size="sm">
                  Sm
                </Button>
              </ContentBlock>
              <CSSuikitInfo>
                <p>
                  appearance="flatten"
                  <br />
                  size="md"
                  <br />
                  size="lg"
                  <br />
                  size="sm"
                  <br />
                </p>
              </CSSuikitInfo>
            </CSSuikitElement>
          </UikitSection>

          <UikitSection label="Text styles">
            {["h1", "h2", "h3", "h4"].map((h, ind) => {
              return (
                <CSSuikitElement key={`h_${ind}`}>
                  <ContentBlock>
                    <HH tag={h}>Heading {ind + 1}</HH>
                  </ContentBlock>
                  <CSSuikitInfo>Heading {ind + 1}</CSSuikitInfo>
                </CSSuikitElement>
              );
            })}
          </UikitSection>

          <UikitSection label="Content block">
            <CSSuikitElement>
              <ContentBlock>Primary</ContentBlock>

              <CSSuikitInfo>appearance="primary" or no appearance</CSSuikitInfo>
            </CSSuikitElement>

            <CSSuikitElement>
              <ContentBlock appearance="flatten">Flatten</ContentBlock>

              <CSSuikitInfo>appearance="flatten"</CSSuikitInfo>
            </CSSuikitElement>

            <CSSuikitElement>
              <ContentBlock appearance="bg">BG</ContentBlock>

              <CSSuikitInfo>appearance="bg"</CSSuikitInfo>
            </CSSuikitElement>

            <CSSuikitElement>
              <ContentBlock appearance="bg-blurred">
                Block Contents
              </ContentBlock>

              <CSSuikitInfo>appearance="bg-blurred"</CSSuikitInfo>
            </CSSuikitElement>

            <CSSuikitElement>
              <ContentBlock appearance="transparent">Transparent</ContentBlock>

              <CSSuikitInfo>appearance="flatten" (with padddings)</CSSuikitInfo>
            </CSSuikitElement>
          </UikitSection>

          <UikitSection label="Background">
            <CSSuikitElement>
              <ContentBlock />

              <CSSuikitInfo>
                <p>Page background or block background</p>
                <p>plain — no image</p>
              </CSSuikitInfo>
            </CSSuikitElement>
          </UikitSection>
        </CSSuikit0>

        <Bg style={{ zIndex: -1 }} />
      </CSSps00>
    </ThemeProvider>
  );
}

export const CSSpsCartPic = styled.div`
  width: 64px;
  height: 64px;
  background: ${(props) => props.theme["colorText"]};
  border-radius: ${(props) => `${props.theme["borderRadius"]}px`};
`;

export const CSSmethod = styled.div`
  background-image: url("https://res.cloudinary.com/maiik/image/upload/v1574923419/Xsolla_Store_icons/payments.svg");
`;
export const CSSmethods = styled.div`
  margin: 0 auto;
  width: 336px;
  height: 44px;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("https://res.cloudinary.com/maiik/image/upload/v1574923419/Xsolla_Store_icons/payments.svg");
`;

export const CSSpsCartLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CSSpsFormFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CSSps00 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* background: black; */
  min-height: 100vh;
`;

const CSSps0 = styled.div`
  flex-direction: column;
  width: 600px;
  box-shadow: 0px 14px 64px rgba(0, 0, 0, 0.04);
  border-radius: 2px;
  display: flex;
  align-items: space-between;
  justify-content: center;
  /* background: ${(props) => props.theme["colorBg"]}; */
  font-size: ${(props) => props.theme["fontSize"]};
  color: ${(props) => props.theme["colorText"]};
`;

const CSSpsF = styled.div`
  border-radius: 8px;
  padding: 44px;
  position: relative;
`;

const CSSpsB = styled.div`
  flex-grow: 1;
  padding: 44px;
  position: relative;
  z-index: 1;
`;
